module.exports = __webpack_public_path__ + "img/gittertraeger_02.a157d0c1.svg";